import { SpinnerService } from '@app/estimates/services/spinner.service';
import { Injectable } from '@angular/core';
import { ServerConnectService } from '@app/core/services/server-connect.service';
import { CommonService } from '@app/shared/services/common.service';
import { FirebaseDataService } from '@app/shared/services/firebase-data.service';
import { activityUriConfig } from '@app/trips/constants/trip-config-url';
import { TRIP_SERVICE_CONSTANT } from '@app/trips/constants/trips-constant-config';
import { CharterPrice, LegInformationDeatils, Vendor } from '@app/trips/schedule-creation/model/schedule-model';
import { BackendActivateTripLeglistFormat, BackendActivateTripTripFormat, BackendFormatSavedraft, GetTCEDataByDraftIDResponse, GetTripEstimateDetailsResponse, ServiceVendorModel, DownloadCharterEstimateOnTripid } from '../model/estimates.model';
import { DeleteLegChange } from '@app/trips/schedule-creation/model/leg-changes';
import { Subject } from 'rxjs';
import { RatingService } from '@app/shared/services/rating.service';

@Injectable({
  providedIn: 'root'
})
export class TceService {
  public tripID: any;
  public srid: number;
  public status: string;
  public totalPrice: number;
  public totalCost: number = 0;
  public fuelPrice: number = 0;
  public tcePrice:number;
  public tripInformation = new Array<LegInformationDeatils>();
  public selectedVendorList = new Array<ServiceVendorModel>();
  public reloadschedule = new Subject<boolean>();
  public charterOperatorCost: number = 0;
  public charterCost: number = 0;
  public tripType: string;
  public finalCharterPrice: number = 0;
  public uniqueID:string;
  private chargeLegId :any;
  public charterCostRev:number = 0;
  public newcharterCost:number = 0;
  public newcharterCurr : any;
  public estimateType:any;
  public legModification:boolean;
  public charterprices : any;
  public chartertimes : any;
  public leglist : any;
  constructor(private connectToServer: ServerConnectService,
     private firebaseDataService: FirebaseDataService,
     private commonService: CommonService,
     private ratingService:RatingService,
    private spinnerService:SpinnerService) { }
  public getDraftEstimate() {
    return new Promise((resolve, reject) => {
      const databody = "trip_id=" + this.tripID;
      this.connectToServer.connectToServer(0, activityUriConfig.GetTCEDataByDraftID, databody, false, false, false).then((response: any) => {
        this.charterOperatorCost = response.GetTCEDataByDraftID?.charterdata?.DraftCharterPrice;
        this.charterprices = response.GetTCEDataByDraftID?.newcharterdata?.charterprices;
        this.chartertimes = response.GetTCEDataByDraftID?.newcharterdata?.chartertimes;
       resolve({
        charterprices: this.charterprices,
        chartertimes: this.chartertimes,
        tceArray: this.createTceArray(response.GetTCEDataByDraftID?.leglist)
      });
      })
    });
  }

  public createTceArray(arr: any) {
    this.tripInformation = arr;
    this.totalCost = 0;
    let fuelPrice: number = 0;
    const finalFuelPrice: number = 0;
    this.selectedVendorList = [];
    const totalPrice: any[] = [];
    const sumFuelPrice: any[] = [];
    return new Promise((resolve, reject) => {
      arr.map((element: any, index: number) => {
        element.serviceProvider.map((elementData: any) => {
          const sectorSplit = element.sector.substr(5, 9);
          const safePrice = isNaN(Number(elementData.price)) ? 0 : Number(elementData.price);
          if (arr.length - 1 != index && (elementData.serviceName == 'handling' || elementData.serviceName == 'airportcharges') && sectorSplit == elementData.station) {
          } else {
            totalPrice.push(safePrice);
          }
          // this.totalCost += elementData.price;
          if (elementData.serviceName == 'fuel') {
            sumFuelPrice.push(safePrice);
            // fuelPrice += elementData.price
          }
        });
        if (this.status != "Activated") {
          element.legId = index + 1;
        }
        if (this.status == "Activated") {
           const fromICAO = element.fromICAO;
            const toICAO = element.toICAO;
          element.serviceProvider.forEach((elementData: any) => {
              let detectedType;
                if (fromICAO === toICAO) {
                  detectedType = 'same';
                } else if (elementData.station === fromICAO) {
                  detectedType = 'origin';
                } else if (elementData.station === toICAO) {
                  detectedType = 'destination';
                }
            this.selectedVendorList.push(
              new ServiceVendorModel({
                name: elementData.name,
                logo: elementData.logo,
                price: elementData.price,
                vendorId: elementData.vendorId,
                UID: elementData.firebaseuid,
                sector: elementData.sector,
                station: elementData.station,
                chargeId: elementData.chargeId,
                serviceName: elementData.serviceName,
                backendFormat: undefined,
                legId: elementData.legId,
                autoselect: elementData.autoselect,
                clickable: elementData.autoselect != undefined && elementData.autoselect == "true",
                rating:this.ratingService.getAverageRatingForName(elementData.firebaseuid),
                 stationType: elementData.serviceName != 'permit' && elementData.serviceName != 'cbp' ? detectedType: undefined,
              }),
            );
          });
        } else {
          this.selectedVendorList.push(...element.serviceProvider);
        }
      });
      this.totalCost = totalPrice?.reduce((a, b) => {
        return a + (isNaN(Number(b)) ? 0 : Number(b));
      }, 0);
      fuelPrice = sumFuelPrice?.reduce((a, b) => {
        return a + (isNaN(Number(b)) ? 0 : Number(b));
      }, 0);
      this.tcePrice = this.totalCost - fuelPrice;
      if(this.charterOperatorCost && this.estimateType == "leg change" && this.legModification == true) {
        this.charterCost = this.charterOperatorCost > 0 ? this.tcePrice || 0 : this.charterOperatorCost;
        this.charterCost += this.charterOperatorCost;
      }
      if (this.charterOperatorCost && (this.estimateType == "Update Schedule"  && this.legModification == false)) {
        this.charterCost = this.charterOperatorCost;
      }else{
        this.charterCost = this.charterOperatorCost > 0 ? this.tcePrice || 0 : this.charterOperatorCost;
        this.charterCost += this.charterOperatorCost;
      }
      resolve(this.selectedVendorList);
    });


  }
  public makeServiceVendorArr() {
    let fuelPrice: number = 0;
    let finalFuelPrice: number = 0;
    this.selectedVendorList = [];
    const totalPrice: any[] = [];
    const sumFuelPrice: any[] = [];
    this.tripInformation.forEach(
      (element: LegInformationDeatils, index: number) => {
        if ( this.tripType != "Active Trip") {
          element.legId = index + 1;
        }
        if (index ==  this.tripInformation.length - 1) {
          element.serviceProvider.map((elementData: any) => {
            const sectorSplit = element.sector.substr(5, 9);
            const safePrice = isNaN(Number(elementData.price)) ? 0 : Number(elementData.price);
            if (this.tripInformation.length != elementData.legId && (elementData.serviceName == 'handling' || elementData.serviceName == 'airportcharges') && sectorSplit == elementData.station) {
            } else {
              totalPrice.push(safePrice);
            }
            if (elementData.serviceName == 'fuel') {
              sumFuelPrice.push(safePrice);
            }
          });
        } else {
          if (Array.isArray(element.serviceProvider)) {
          element.serviceProvider
            .filter((item: any) => {
              return item.station != element.sector.substr(5, 9);
            })
            .forEach((element2) => {
              const safePrice = isNaN(Number(element2.price)) ? 0 : Number(element2.price);
              totalPrice.push(safePrice)
              if (element2.serviceName == "fuel") {
              sumFuelPrice.push(safePrice);
              }
            });
          }
        }
        if (this.tripType == "Active Trip") {
          element.serviceProvider.forEach((elementData: any) => {
              const fromICAO = element.sector.substr(0, 4);
            const toICAO = element.sector.split('-')[1];
              // 1. Determine the station type for this specific vendor
                let detectedType;
                if (fromICAO === toICAO) {
                  detectedType = 'same';
                } else if (elementData.station === fromICAO) {
                  detectedType = 'origin';
                } else if (elementData.station === toICAO) {
                  detectedType = 'destination';
                }
            this.selectedVendorList.push(
              new ServiceVendorModel({
                name: elementData.name,
                logo: elementData.logo,
                price: elementData.price,
                vendorId: elementData.vendorId,
                UID: elementData.firebaseuid,
                sector: elementData.sector,
                station: elementData.station,
                chargeId: elementData.chargeId,
                serviceName: elementData.serviceName,
                backendFormat: undefined,
                legId: elementData.legId,
                autoselect: elementData.autoselect,
                clickable:
                  elementData.autoselect != undefined &&
                  elementData.autoselect == "true",
                  rating:this.ratingService.getAverageRatingForName(elementData.firebaseuid), // Active Trip | in Activated TCE
                stationType: detectedType,
                }),
            );
          });
        } else {
          this.chargeLegId.forEach((chargeData: LegInformationDeatils)=>{
            chargeData.serviceProvider.map((chargeFinalData)=>{
              if (Array.isArray(element.serviceProvider)) {
              element.serviceProvider.filter((data)=>{
                data.rating =  this.ratingService.getAverageRatingForName(data.UID)
                if(data.chargeId==1 && data.UID===chargeFinalData.UID && data.serviceName===chargeFinalData.serviceName && data.station===chargeFinalData.station)
                {
                  data.logo=chargeFinalData.logo;
                }
                else if(!data.vendorId)
                {
                  data.logo=chargeFinalData.logo;
                }
                else if(!data.chargeId && data.UID===chargeFinalData.UID && data.serviceName===chargeFinalData.serviceName && data.station===chargeFinalData.station){
                  data.logo=chargeFinalData.logo;
                }
                else{}
              });
              }
            });
          });
           if (Array.isArray(element.serviceProvider)) {
            const fromICAO = element.sector.substr(0, 4);
            const toICAO = element.sector.substr(5, 9);
            element.serviceProvider.forEach((provideres)=>{
                provideres.stationType = provideres.station === fromICAO && provideres.station === toICAO ? 'same': undefined;
            })
          this.selectedVendorList.push(...element.serviceProvider);
          }
        }
      },
    );
    this.totalCost = totalPrice?.reduce((a, b) => {
      return a + (isNaN(Number(b)) ? 0 : Number(b));
    }, 0);
        fuelPrice = sumFuelPrice?.reduce((a, b) => {
          return a + (isNaN(Number(b)) ? 0 : Number(b));
        }, 0);
        finalFuelPrice = this.totalCost - fuelPrice;
  }
  public saveEstimateTripData(tripInformation: LegInformationDeatils[], deleteLegstatus: DeleteLegChange[], estimateID?, type?: string, isLegEdited?,legModificationEst?,isAccepted?) {
    this.estimateType = type;
    this.legModification = legModificationEst;
    return new Promise((resolve, reject) => {

      if(isLegEdited && isLegEdited=='edit')
      {
        tripInformation.map((element,index)=>{
          element.legId = index+1;
          element.serviceProvider.forEach((element1: ServiceVendorModel) => {
          element1.rating =  this.ratingService.getAverageRatingForName(element1.UID)
          return element1.legId = index+1 ;
          });

        })
      }
      // inside conditiopn
      this.spinnerService.show(TRIP_SERVICE_CONSTANT.estimateText)
      // this.commonService.showSpinnerLoader(TRIP_SERVICE_CONSTANT.estimateText);
      const tripData = new Array<BackendFormatSavedraft>();
      this.chargeLegId = tripInformation;
      tripInformation.forEach((element: LegInformationDeatils) => {
        tripData.push(new BackendFormatSavedraft(element));
      });
      const payload =
        "data=" +
        encodeURIComponent(JSON.stringify(tripData)) +
        "&trip_id=" +
        estimateID +
        "&deletedarray=" +
        JSON.stringify(deleteLegstatus);
      this.connectToServer.connectToServer(0, type == 'leg change' ? activityUriConfig.GetLegchangeTCE : activityUriConfig.saveRawTripData, payload, false, false, false).then(
        (tripDataValue: any) => {
          this.spinnerService.hide();
          this.tripID = tripDataValue.saveRawTripData;
          if (type == "leg change") {
            resolve(tripDataValue.GetTCEDataAfterLegchange);
            this.charterCostRev = tripDataValue.GetTCEDataAfterLegchange.CharterPrice;
            this.newcharterCost = tripDataValue.GetTCEDataAfterLegchange.newcharterdata?.charterprices?.TotalPrice;
            this.newcharterCurr = tripDataValue.GetTCEDataAfterLegchange.newcharterdata?.charterprices?.Currency;
          } else {
            resolve(isAccepted=='0'? tripDataValue.saveRawTripData: tripDataValue);
          }
          // this.commonService.dissmissSpinnerLoader();
        },
        (error) => {
          // this.commonService.dissmissSpinnerLoader();
          this.spinnerService.hide();
        }
      );
    });
  }
  public downlaodTripEstimate(tripId) {
  return new Promise(async (resolve, reject) => {
    try {
      this.tripID  = tripId ? tripId:this.tripID;
      const databody = "id=" + this.tripID;
      this.commonService.showSpinnerLoader();
      this.charterprices = this.charterprices || {};
      this.charterprices.chartertimes = this.chartertimes || {};
      if(this.charterprices && Object.keys(this.charterprices).length > 0 &&this.chartertimes && Object.keys(this.chartertimes).length > 0){
      await this.processSaveCharterPrice(this.charterprices, this.tripID, '');
      }
      this.connectToServer.connectToServer(0, activityUriConfig.GetTripEstimateDetails, databody, false, false, false).then((res: GetTripEstimateDetailsResponse) => {
        this.commonService.dissmissSpinnerLoader();
        this.firebaseDataService.getFileFormPath(res.GetTripEstimateDetails);
          resolve(res);
      });
    } catch (err) {
      this.commonService.dissmissSpinnerLoader();
      reject(err);
    }
  });
  }
  public async activateTrip() {
    return await new Promise((resolve, reject) => {
      this.spinnerService.show(TRIP_SERVICE_CONSTANT.registerTripLoader);
      // this.commonService.showSpinnerLoader(TRIP_SERVICE_CONSTANT.registerTripLoader);
      const paylaoad = "data=" + JSON.stringify(this.activateTCE());
      this.connectToServer.connectToServer(0, activityUriConfig.ActivateTCE, paylaoad, false, false, false).then((data: any) => {
        resolve(data);
      });
    }).catch((error)=>{
      this.spinnerService.hide();
    })
  }
  public activateTCE() {
    const backendActivateTripLeglistFormat = new Array<
      BackendActivateTripLeglistFormat
    >();
    const tripData = new BackendActivateTripTripFormat();
    tripData.legList = backendActivateTripLeglistFormat;
    const stationServiceArray = [];
    this.tripInformation.forEach((element: LegInformationDeatils, index: number) => {
      backendActivateTripLeglistFormat.push(
        new BackendActivateTripLeglistFormat(element)
      );
      tripData.SectorServiceArray.push({
        service: "cbp,navigation,permits,",
        sector: element.sector,
      });

      let service: string = "";
      const servicArr = element.serviceProvider.filter((item) => {
        return item.station == element.sector.substr(0, 4);
      });
      servicArr.forEach((serviceElement: Vendor) => {
        if (serviceElement.serviceName == "fuel") {
          if (
            serviceElement.UID != this.commonService.uid
          ) {
            service = service + "fuel,";
          }
        }
        if (serviceElement.serviceName == "handling") {
          if (
            serviceElement.UID != this.commonService.uid
          ) {
            service = service + "groundhandling,";
          }
        }
        if (serviceElement.serviceName == "airportcharges") {
          if (
            serviceElement.UID != this.commonService.uid
          ) {
            service = service + "airportcharges,";
          }
        }
      });
      tripData.StationServiceArray.push({
        service,
        sector: element.sector,
        station: element.sector.substr(0, 4),
      });
      if (index == this.tripInformation.length - 1) {
        service = "";
        const secondServicArr = element.serviceProvider.filter((item) => {
          return item.station == element.sector.substr(5, 9);
        });
        secondServicArr.forEach((serviceElement: Vendor) => {
          if (serviceElement.serviceName == "fuel") {
            if (
              serviceElement.UID != this.commonService.uid
            ) {
              service = service + "fuel,";
            }
          }
          if (serviceElement.serviceName == "handling") {
            if (
              serviceElement.UID != this.commonService.uid
            ) {
              service = service + "groundhandling,";
            }
          }
          if (serviceElement.serviceName == "airportcharges") {
            if (
              serviceElement.UID != this.commonService.uid
            ) {
              service = service + "airportcharges,";
            }
          }
        });
        element.stationCheck ?
        tripData.StationServiceArray.push({
          service: '',
          sector: element.sector,
          station: element.sector.substr(5, 9),
        })
         :tripData.StationServiceArray.push({
          service,
          sector: element.sector,
          station: element.sector.substr(5, 9),
        });
      }
    });
    tripData.TotalCost = this.totalCost;
    return tripData;
  }
  public deleteDraftTrip(tripId: number, estimateId: number) {
    return new Promise((resolve) => {
      const paylaoad =
        "trip_id=" + estimateId + "&SRID=" + JSON.stringify(tripId);
      this.connectToServer.connectToServer(0, activityUriConfig.updateDraftTrip, paylaoad, false, false, false).then((data: any) => {
        resolve(data.UpdateDraftTrip);
      }).catch((err)=>{
        this.spinnerService.hide();
      });
    });
  }
  public getLegChangeTCE() {
    return new Promise((resolve, reject) => {
      // this.commonService.showSpinnerLoader();
      this.spinnerService.show(TRIP_SERVICE_CONSTANT.revisingTrip);
      const databody = "SRID=" + this.srid + "&uniqid=" + this.uniqueID;
      this.connectToServer.connectToServer(0, activityUriConfig.legChangesActivateTrip, databody, false, false, false).then((data: any) => {
        // this.commonService.dismissLoader();
        this.spinnerService.hide();
        resolve(data.GetTCEDataByDraftID);
      },
        (err) => {
          // this.commonService.dismissLoader();
          this.spinnerService.hide();
          reject(err);
        }
      );
    });
  }
   // for charter ratebreakup
  public async processSaveCharterPrice(data: CharterPrice, estimateId: number,message:any, text?:any, hideSpinner: boolean = true): Promise<any> {
   if (message === false) {
    this.spinnerService.show(TRIP_SERVICE_CONSTANT.updatecharterQuote);
   }
    if(message == 'charter') {
      data.OperatorAccepted = data.OperatorAccepted == 0 ? 1: data.OperatorAccepted;
    }
    const payload = "data=" + JSON.stringify(data) + (text == 'saveOnly' || this.tripType !='Leg Change Estimate' ? "&EstimateID="+ estimateId : "&TripID="+ estimateId);
    try {
      const response: any = await this.connectToServer.connectToServer(
        0,
        activityUriConfig.UpdateCharterEstimateData,
        payload,
        false,
        false,
        false
      );
      if (hideSpinner) {
        this.spinnerService.hide();
      }

      if (response.ResponseStatus === 'Success') {
        return response;
      }
    } catch (error) {
      this.spinnerService.hide();
      throw error;
    }
  }

  public async activatecharter(data: CharterPrice, estimateId: number, TripData:any): Promise<any> {
    const leglist = JSON.stringify(TripData)
    const encodedData = encodeURIComponent(leglist);
    this.spinnerService.show(TRIP_SERVICE_CONSTANT.Activate);
    const payload = "data=" + JSON.stringify(data) + "&estimateDraftId=" + estimateId + "&leglist=" +  encodedData;
    try {
      const response: any = await this.connectToServer.connectToServer(
        0,
        activityUriConfig.ClientCharterRegisterTrip,
        payload,
        false,
        false,
        false
      );
      this.spinnerService.hide();
      if (response.ResponseStatus === 'Success') {
        return response;
      } else {
        throw new Error('API returned failure: ' + response.ResponseCode);
      }
    } catch (error) {
      this.spinnerService.hide();
      throw error;
    }
  }
  // for charter estimate download after activate trip
  public DownloadCharterEstimateOnTripid(ActivatedtripId: string) {
  return new Promise((resolve, reject) => {
    const databody = 'tripid=' + ActivatedtripId;
    this.commonService.showSpinnerLoader();
    this.connectToServer.connectToServer(0,activityUriConfig.DownloadCharterEstimateOnTripid,databody,false, false, false).then((res: any) => {
      resolve(res.DownloadCharterIternaryPDF);
    }).catch((error) => {
      this.commonService.dissmissSpinnerLoader();
      reject(error);
    });
  });
}
public DownloadCharterEstimate(tripId: string){
  return new Promise((resolve, reject) => {
    const databody = 'estimate_id=' + tripId;
    this.commonService.showSpinnerLoader();
    this.connectToServer.connectToServer(0,activityUriConfig.DownloadCharterEstimate,databody,false, false, false).then((res: any) => {
      resolve(res.DownloadCharterIternaryPDF);
    }).catch((error) => {
      this.commonService.dissmissSpinnerLoader();
      reject(error);
    });
  });
}
}
